module.exports = __webpack_public_path__ + "static/media/generic-rad.4d858674.jpeg";